import { GoogleTagService } from '@apparel/ui/lib/GoogleTag';
import { GTag } from '@apparel/ui/lib/utils';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useCallback } from 'react';

const useStyles = makeStyles(() => ({
    cartButton: {
        opacity: 0,
        transitionDelay: '150ms',
        transform: 'translate3d(0, 14px, 0)',
        transition: 'opacity 250ms, transform 400ms',
    },
    designButton: {
        height: 56,
        color: '#fff',
        width: '100%',
        borderRadius: '40px',
        marginBottom: '20px',
        backgroundColor: '#e4002b',
        '&:hover': {
            backgroundColor: '#e4002b',
        },
    },
}));

interface CustomdesignButtonProps {
    modelId: number;
    modelType: string;
    categoryId: number;
    categoryName: string;
    packageItems?: any;
    minimumOrder?: number;
    isSizingKit?: boolean;
    subcategoryId?: number;
    isCustom?: boolean;
    name?: string;
}

export function CustomDesignButton({
    isSizingKit,
    categoryId,
    categoryName,
    modelType,
    packageItems,
    modelId,
    minimumOrder,
    subcategoryId,
    isCustom,
    name = 'GET A FREE CUSTOM DESIGN',
}: CustomdesignButtonProps) {
    const classes = useStyles();
    const handleRequestDesign = useCallback(
        (event) => {
            event.preventDefault();
            event.stopPropagation();

            const items = {
                extras: {},
                packages: {},
            };

            const item = {};

            if (modelType === 'package') {
                const subcategories: any[] = [];

                (packageItems ?? []).forEach((packageItem) => {
                    subcategories.push({
                        subcategory_id: packageItem.subcategory_id,
                        sku_id: packageItem?.sku_id || packageItem?.default_sku_id,
                        default_sku: {
                            id: packageItem?.sku_id || packageItem?.default_sku_id,
                            name: packageItem.name,
                            preview_photo: {
                                thumbnail_path: packageItem.thumbnail_path,
                            },
                            minimum_order_quantity: packageItem.minimum_order_quantity,
                        },
                    });
                });

                item[modelId] = {
                    id: modelId,
                    quantity: Math.max(minimumOrder, 1),
                    subcategories: subcategories,
                    category_id: categoryId,
                };

                items.packages = item;
            } else {
                item[modelId] = {
                    id: modelId,
                    quantity: Math.max(minimumOrder, 1),
                    category_id: categoryId,
                    subcategory_id: subcategoryId,
                };

                items.extras = item;
            }
            localStorage.setItem('DR_FROM@GO', JSON.stringify(items));
            GoogleTagService.reportConversion(GTag.Design_Request_Started);
            setTimeout(() => (window.location.href = '/platform/designs/request/view/products'), 250);
        },
        [modelId, modelType, categoryId, categoryName, minimumOrder, packageItems],
    );

    return (
        <>
            {!isSizingKit ? (
                <Box>
                    <Button
                        color={isCustom ? 'default' : 'primary'}
                        className={isCustom ? classes.designButton : classes.cartButton}
                        variant={'contained'}
                        size={'large'}
                        onClick={handleRequestDesign}
                        disableElevation
                    >
                        {name}
                    </Button>
                </Box>
            ) : null}
        </>
    );
}
